$(function(){

    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const common = require('./_data/common.json');
    const links = require('./_data/links');
    const locations = require('./_data/locations.json')
    const forms = require('./_data/forms.json')
    
    // defaults
    let prefix;
    switch (language) {
        case "is-en":
        case "is":
            prefix = "youpret_iceland";
            break;
        case "ee-en":
        case "ee":
        case "ee-ru":
            prefix = "youpret_estonia";
            break;
        default:
            prefix = "youpret";
    }
    // defaults
    $.ajaxSetup({
        headers: {
            "X-TimeZoneName": timeZoneName,
            "X-Language": language,
            "X-Prefix": prefix
        },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd : envSettings.server + "/json/bookings/add"
    }

    
    let languages = {};
    let step = 0;
    try {
        languages = JSON.parse(pageLanguages);  
    }catch(err) {
        //console.log(err.message);
    }

    try {
        step = $("#step").val() ? $("#step").val() : 0;
        console.log("step " + step);
    }catch(err) {
        console.log(err.message);
    }
    updateOrderFromUrlParams();
    updateForm();


    $('orderForm').submit(false);
    $("#orderFromLanguage").on('input',function(e){updateOrder();});
    $("#orderToLanguage").on('input',function(e){updateOrder();});
    $("#orderTypeBooking").on('input',function(e){updateOrder();});
    $("#orderTypeInstant").on('input',function(e){updateOrder();});
    $("#orderTypeOnSite").on('input',function(e){updateOrder();});
    $("#orderSecurityClearedTrue").on('input',function(e){updateOrder();});
    $("#orderSecurityClearedFalse").on('input',function(e){updateOrder();});
    $('#orderStartDate').on('input',function(e){updateOrder();});
    $('#orderStartTime').on('input',function(e){updateOrder();});
    $("#orderDurationInMinutes").on('input',function(e){updateOrder();});
    $('#orderFirstName').on('input',function(e){ updateOrder(); });
    $('#orderLastName').on('input',function(e){ updateOrder(); });
    $('#orderOrganizationName').on('input',function(e){ updateOrder(); });
    $('#orderOrganizationBusinessId').on('input',function(e){ updateOrder(); });
    $('#orderPhoneNumber').on('input',function(e){ updateOrder(); });
    $('#orderEmail').on('input',function(e){ updateOrder(); });
    $('#orderNotes').on('input',function(e){ updateOrder(); });
    $('#orderBillingAddress').on('input',function(e){ updateOrder(); });

    $("#orderLocations").on("input", function (e) {updateOrder(); });
    $("#orderOnSiteAddress").on("input", function (e) {updateOrder(); });
    $("#orderOnSiteBillingAddress").on("input", function (e) {updateOrder(); });
    $("#orderOnSiteCity").on("input", function (e) {updateOrder(); });
    $("#orderOnSiteLocationInfo").on("input", function (e) {updateOrder(); });
    $("#orderLocationOther").on("input", function (e) {updateOrder(); });
    $("#orderPaymentType").on("input", function (e) {updateOrder(); });
    $("#orderDrivingSchoolName").on("input", function (e) {updateOrder(); });

    function sendOrder(order){
        setSendBtnDisabled();
        let locale = $("#locale").val();
        if(order.location === "other") {
            order.location = order.locationOther
        }
        // TODO: send prefix if Iceland
        let data = {
            customerFirstName: order.firstName, 
            customerLastName: order.lastName,
            customerOrganizationName: order.organizationName, 
            customerPhoneNumber: order.phoneNumber,
            customerEmail: order.email, 
            customerNotes: order.customerNotes,
            fromLanguage: order.fromLanguage, 
            toLanguage: order.toLanguage,
            startDate: new Date(order.startDate + " " + order.startTime + ":00").toISOString(),
            durationInMinutes: order.durationInMinutes,
            location: order.location,
            paymentType: order.paymentType,
            billingAddress: order.billingAddress,
            type: order.type,
            typeName: order.typeName,
            drivingSchoolName: order.drivingSchoolName,
            securityCleared: order.securityCleared,
            address: order.onSiteAddress,
            zip: order.onSiteBillingAddress,
            city: order.onSiteCity,
            info: order.onSiteLocationInfo,
            tags: order.tags,
            customerOrganizationBusinessId: "",
            languageCode: locale,
            };

        $.ajax({
            url: Uris.jsonBookingsAdd,
            method:"POST",
            data: JSON.stringify(data)
        })
        .done(function( data ) {
            console.log("success");
            console.log(data);
            sessionStorage.removeItem('order');

            let nextPageUri = $("#orderNextPageUri").val();
            console.log("nextPageUri", nextPageUri);
            window.location.href = nextPageUri;
            setSendBtnActive();
        })
        .fail(function(err){
            console.log("error");
            console.log(err);
            setSendBtnActive();
            showAlert()
        });
    }

    if(step == 0) {
        sessionStorage.removeItem('order');
    }

    $("#orderSendBtn").on("click", function(event)
        {
            if( $('#orderForm')[0].checkValidity()){
            console.log("step", step);

            event.preventDefault();
                
                
                if(sessionStorage.order === null || sessionStorage.order === undefined){
                    // needed for example on ru start page where user does not do any selections.
                    updateOrder();
                }
                let order = JSON.parse(sessionStorage.order);
                if(order.tags.includes("drivingSchool")) {
                    
                    if (step == 5) {
                        sendOrder(order)
                    }else{
                        if (order.type === "ON_SITE") {
                            let nextPageUri = $("#orderNextPageUri").val();
                            window.location.href = nextPageUri;
                        }
                    }
                } else if(order.tags.includes("legal") || order.tags.includes("childhood_education") || order.tags.includes("health") || order.tags.includes("business") || order.tags.includes("mental_health"))  {
                    if (step == 4) {
                        sendOrder(order)
                    }else if (step == 1){
                        if (order.type === "ON_SITE") {
                            let nextPageUri = $("#orderOnSitePageUri").val();
                            window.location.href = nextPageUri;
                        } else if(order.type === "INSTANT"){
                            let nextPageUri = $("#orderInstantInterpreterPageUri").val();
                            window.location.href = nextPageUri;
                        } else if(order.type === "BOOKING"){
                            let nextPageUri = $("#orderBookingInterpreterPageUri").val();
                            window.location.href = nextPageUri;
                        } else {
                            alert("Valitse tulkkauksen tyyppi")
                        }
                    } else {
                        let nextPageUri = $("#orderNextPageUri").val();
                        window.location.href = nextPageUri;
                    }
                }else {
                  if (step == 2) {
                        if(order != null){
                            if(order.startDate) $("#orderStartDate").val(order.startDate);
                            if(order.startTime) $("#orderStartTime").val(order.startTime);
                            var now = new Date();
                            var orderDateTime = new Date(order.startDate + " " + order.startTime + ":00");
                            if (orderDateTime < now) {
                              $("#orderNextPageUri").prop("value", links[language].orderInterpreter2);
                              window.alert(common[language].dateError);
                            } 
                            else if(orderDateTime > now){
                                $("#orderNextPageUri").prop("value", links[language].orderInterpreter3);
                            }else {
                                console.log("Error")
                            }
                        }
                    }
                    if (step == 3){
                       sendOrder(order);
                    }else if(step == 8){
                        sendOrder(order);
                    }else if(step > 5){
                        let nextPageUri = $("#orderNextPageUri").val();
                        window.location.href = nextPageUri;
                    
                    }else {
                        if(order.type === "BOOKING"){
                            let nextPageUri = $("#orderNextPageUri").val();
                            window.location.href = nextPageUri;
                        }else if(order.type === "INSTANT"){
                            let nextPageUri = $("#orderInstantInterpreterPageUri").val();
                            window.location.href = nextPageUri;
                        }
                        else if(order.type === "ON_SITE") {
                            let nextPageUri = $("#orderOnSitePageUri").val();
                            window.location.href = nextPageUri;
                    }
                       
                    } 
                }
            }
        }
    );

    function stringToDate(dateString){
        let date = new Date(dateString);
        let formatted_date = date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
        return formatted_date;
    }

    function fullHours(minutes){
        let hours = (minutes / 60);
        let rhours = Math.floor(hours);
        return rhours;
    }

    function remainingMinutes(minutes){
        let hours = (minutes / 60);
        let rhours = Math.floor(hours);
        let mins = (hours - rhours) * 60;
        let remainingMinutes = Math.round(mins);
        return remainingMinutes;
    }

    function updateForm(){
        console.log('updateForm called ' + window.location);
        if(sessionStorage.order != null){
            let order = JSON.parse(sessionStorage.order);
            if(order.fromLanguage) $("#orderFromLanguage").val(order.fromLanguage);
            if(order.toLanguage) $("#orderToLanguage").val(order.toLanguage);
            if(order.type){
                if(order.type === 'BOOKING') $('#orderTypeBooking').prop('checked',true);
                if(order.type === 'INSTANT') $('#orderTypeInstant').prop('checked',true);
                if(order.type === 'ON_SITE') $('#orderTypeOnSite').prop('checked',true);
            }
            if(order.startDate) $("#orderStartDate").val(order.startDate);
            if(order.startTime) $("#orderStartTime").val(order.startTime);
            if(order.durationInMinutes) $("#orderDurationInMinutes").val(order.durationInMinutes);
            if(order.firstName) $("#orderFirstName").val(order.firstName);    
            if(order.lastName) $("#orderLastName").val(order.lastName);    
            if(order.organizationName) $("#orderOrganizationName").val(order.organizationName);    
            if(order.organizationBusinessId) $("#orderOrganizationBusinessId").val(order.organizationBusinessId);    
            if(order.phoneNumber) $("#orderPhoneNumber").val(order.phoneNumber);    
            if(order.email) $("#orderEmail").val(order.email);    
            if(order.customerNotes) $("#orderNotes").val(order.customerNotes);
            if(order.location) $("#orderLocations").val(order.location);
            if(order.locationOther) $("#orderLocationOther").val(order.locationOther);
            if(order.paymentType) $("#orderPaymentType").val(order.paymentType);  
            if(order.onSiteAddress) $("#orderOnSiteAddress").val(order.onSiteAddress);
            if(order.onSiteBillingAddress) $("#orderOnSiteBillingAddress").val(order.onSiteBillingAddress);
            if(order.onSiteCity) $("#orderOnSiteCity").val(order.onSiteCity);
            if(order.onSiteLocationInfo) $("#orderOnSiteLocationInfo").val(order.onSiteLocationInfo);
            if(order.billingAddress) $("#orderBillingAddress").val(order.billingAddress);  
            if(order.drivingSchoolName) $("#orderDrivingSchoolName").val(order.drivingSchoolName); 
            if(order.securityCleared) {
                if(order.securityCleared === true) $('#orderSecurityClearedTrue').prop('checked',true); 
                if(order.securityCleared === false) $('#orderSecurityClearedFalse').prop('checked',true);
            }
            
            let formattedStartDate = stringToDate(order.startDate);

            let durationHours = fullHours(order.durationInMinutes);
            let durationMinutes = remainingMinutes(order.durationInMinutes);
            let formattedDuration = (durationHours > 0 & durationHours != 1 ? durationHours + " " + common[language].hours + " " : "" | durationHours == 1 ?  durationHours + " " + common[language].hour + " " : "") + (durationMinutes > 0 ? durationMinutes + " " + common[language].minutes + " " : "");

            let languagesHtml = '<p><b>' + order.fromLanguageName + ' - ' + order.toLanguageName + '</b></p>';
            let typeHtml = '<p><b>' + order.typeName +  '</b></p>';
            let dateHtml = "";
            let durationHtml = "";
            let locationHtml = ""

            if(order.tags.includes("drivingSchool")) {
                if (step > 1) {
                    if(order.location === "other") {
                        locationHtml = "<p><b>" + order.locationOther + "</b></p>";
                    }else {
                        locationHtml = "<p><b>" + order.location + "</b></p>";

                        if (order.drivingSchoolName != null && order.drivingSchoolName != "") {
                            locationHtml = locationHtml + "<p><b>" + order.drivingSchoolName + "</b></p>";
                        }
                    }
                }
                if (step > 2) {
                    dateHtml = "<p><b>" +formattedStartDate + " " + order.startTime + "</b></p>";durationHtml = "<p><b>" +(order.durationInMinutes > 0 ? formattedDuration : "") + "</b></p>";
                }

                $("#orderType").val("drivingSchool");
                $("#orderSummary").html(
                    languagesHtml + locationHtml + dateHtml + durationHtml
                );

                locations[language].drivingSchoolLocations.forEach((city) => {
                    if (city && city.languageTags.includes(order.toLanguage)) {
                        city.locations.forEach((location) => {
                            if (location) {
                                $("#orderLocations").append($("<option></option>").attr("value", location.name).text(location.name));
                            }
                        });
                    }
                });
                $("#orderLocations").append($("<option></option>").attr("value", "other").text("Muu toimipiste"));

            } 
            else if (order.tags.includes("legal") || order.tags.includes("childhood_education") || order.tags.includes("health") || order.tags.includes("business") || order.tags.includes("mental_health") ) {
                if (step > 1) {
                    let orderSecurityClearedStatus = "Ei"
                    if(order.securityCleared === "true") {
                        orderSecurityClearedStatus = "Kyllä"
                    }
                   
                    typeHtml = "<p><b>" + order.typeName + "</b></p>"
                   
                    if(order.tags.includes("legal")) {
                        typeHtml = "<p><b>" + "Turvaselvitetty: " + orderSecurityClearedStatus + "</b></p>";
                    }
                    
                }
                if (step > 2) {
                    if(order.location === "other" && order.type === "ON_SITE") {
                        locationHtml = "<p><b>" + order.locationOther + "</b></p>";
                    }
                }
                if (step > 3) {
                    dateHtml = "<p><b>" +formattedStartDate + " " + order.startTime + "</b></p>";durationHtml = "<p><b>" +(order.durationInMinutes > 0 ? formattedDuration : "") + "</b></p>";
                }
                if (order.tags.includes("legal")){
                    $("#orderType").val("legal");
                }else if(order.tags.includes("childhood_education")) {
                    $("#orderType").val("childhood_education");
                }else if(order.tags.includes("health")) {
                    $("#orderType").val("health");
                }else if(order.tags.includes("business")) {
                    $("#orderType").val("business");
                }else if(order.tags.includes("mental_health")) {
                    $("#orderType").val("mental_health");
                }
                
                $("#orderSummary").html(
                    languagesHtml + typeHtml + locationHtml + dateHtml + durationHtml
                );
            }else{
                if(step > 2){
                    dateHtml = '<p><b>' + formattedStartDate + ' ' +  order.startTime + '</b></p>'
                    durationHtml = '<p><b>' + (order.durationInMinutes > 0 ? formattedDuration : "") + '</b></p>';
                }
                if (step == 6) {
                    dateHtml = "";
                    durationHtml = "";
                }
                if (step > 7) {
                    locationHtml = "<p><b>" + order.onSiteAddress + "</b></p>" + "<b>" + order.onSiteBillingAddress + "</b>" + "<b>" + "    "  +  order.onSiteCity + "</b>";}
                $('#orderSummary').html(
                     typeHtml
                    + languagesHtml
                    + dateHtml
                    + durationHtml
                    + locationHtml
                    );
                $("#orderType").val("orderInterpretation");
      }}
      else{
        // TODO: koko lohko toimii vain suomenkielisillä osoitteilla:
        console.log("language", language);
        console.log("TODO: koko lohko toimii vain suomenkielisillä osoitteilla:");
        let backToStartLink = links[language].orderInterpreter;
        if(step > 2 || !sessionStorage.order) {
            if(window.location.href.includes("autokoulun-teoriakoe")) {
                backToStartLink = links[language].orderInterpreterDrivingSchool1
            }else if (window.location.href.includes("oikeustulkki")) {
                backToStartLink = links[language].orderInterpreterLegal1
            }else if (window.location.href.includes("varhaiskasvatus-tulkki")) {
                backToStartLink = links[language].earlyChildhoodEducation1
            }else if (window.location.href.includes("bisnestulkki")) {
                backToStartLink = links[language].orderBusinessInterpreter1
            }
            else if (window.location.href.includes("mielenterveys")) {
                backToStartLink = links[language].orderMentalHealthInterpreter1
            }
            else if (window.location.href.includes(links[language].orderIdentifier)) {
                backToStartLink = links[language].orderOnSiteInterpreter
            }
            let errorMessage = '<p class="text-danger"><b>' + common[language].alertMissingDetails + "<a href='"+ backToStartLink + "'> " + common[language].here + ".</a>" + '</b></p>'
            $('#orderSummary').html(errorMessage);
        }else{
            console.log("backToStartLink option not set");
        }
        console.log('order in session storage is null. No update needed. Uses defaults.');
    }
    }
    function parseOrderOrCreateNew(){
        let order = {};
        if(sessionStorage.order == null){
            console.log('init sessiontorage object order');
            order.fromLanguage = "fi";
            order.fromLanguageName = "";
            order.toLanguage = "";
            order.toLanguageName = "";
            order.type = "BOOKING";
            order.typeName = "";
            order.startDate = "";
            order.startTime = "";
            order.durationInMinutes = 0;
            order.firstName = "";
            order.lastName = "";
            order.organizationName = "";
            order.organizationBusinessId = "";
            order.phoneNumber = "";
            order.email = "";
            order.customerNotes = "";
            order.location = "";
            order.paymentType = "";
            order.onSiteAddress = "";
            order.onSiteAddressCity = "";
            order.onSiteBillingAddress = "";
            order.onSiteLocationInfo = "";
            order.billingAddress = "";
            if(window.location.href.includes('autokoulun-teoriakoe') === true) {
                order.tags = ["drivingSchool"]
                order.type = "ON_SITE";
                order.customerNotes = forms[language].drivingSchoolTest;
                order.paymentType = forms[language].paymentOptionsBankCard;
                order.drivingSchoolName = "";
            }else if(window.location.href.includes('oikeustulkki') === true) {
                order.securityCleared = false;
                order.tags = ["legal"]
                order.type = "";
                order.location = "other"
                order.customerNotes = forms[language].legalInterpreter;
            }else if(window.location.href.includes('varhaiskasvatus-tulkki') === true) {
                order.securityCleared = false;
                order.tags = ["childhood_education"]
                order.type = "";
                order.location = "other"
                order.customerNotes = forms[language].childhoodEducationInterpreter;
            }else if(window.location.href.includes('terveystulkki') === true) {
                order.securityCleared = false;
                order.tags = ["health"]
                order.type = "";
                order.location = "other"
                order.customerNotes = forms[language].healthInterpreter;
            }else if(window.location.href.includes('bisnestulkki') === true) {
                order.securityCleared = false;
                order.tags = ["business"]
                order.type = "";
                order.location = "other"
                order.customerNotes = forms[language].businessInterpreter;
            }else if(window.location.href.includes('mielenterveys') === true) {
                order.securityCleared = false;
                order.tags = ["mental_health"]
                order.type = "";
                order.location = "other"
                order.customerNotes = forms[language].mentalHealthInterpreter;
            }else if(window.location.href.includes(links[language].orderIdentifier) === true) {
                order.securityCleared = false;
                order.tags = ["onsite"]
                order.type = "ON_SITE";
                order.location = "other"
                
            } else {
                order.tags = []
            }
            sessionStorage.order = JSON.stringify(order);
        }else{
            order = JSON.parse(sessionStorage.order);
        }
        return order;
    }


    function updateOrderFromUrlParams(){
        console.log('updateOrderFromUrlParams called ' + window.location);
        
        const queryString = window.location.search;
        if(queryString){
            const urlParams = new URLSearchParams(queryString);
            const urlParamFromLanguage = urlParams.get('fromLanguage');
            const urlParamToLanguage = urlParams.get('toLanguage');
            const urlParamType = urlParams.get('type');

            let order = parseOrderOrCreateNew();
            if(urlParamFromLanguage != null){
                order.fromLanguage = urlParamFromLanguage
                order.fromLanguageName = languages[urlParamFromLanguage].name;
            } 
            if(urlParamToLanguage != null){
                order.toLanguage = urlParamToLanguage
                order.toLanguageName = languages[urlParamToLanguage].name;
            }
            
            if(urlParamType === 'BOOKING'){
                order.type = urlParamType;
                order.typeName = common[language].booking;
            }else if(urlParamType === 'INSTANT'){
                order.type = urlParamType;
                order.typeName = common[language].booking;
            }else if(urlParamType === 'ON_SITE'){
                order.type = urlParamType;
                order.typeName = common[language].onSite;
            }

            console.log("updateOrderFromUrlParams: sessionsStorage order updated"); 
            sessionStorage.order = JSON.stringify(order);
        }

    }

    function updateOrder() {
       // console.log('updateOrder called');
        let order = parseOrderOrCreateNew();
        
        let fromLanguage = $("#orderFromLanguage").children("option:selected").val();
        let fromLanguageName = $("#orderFromLanguage").children("option:selected").text();
        let toLanguage = $("#orderToLanguage").children("option:selected").val();
        let toLanguageName = $("#orderToLanguage").children("option:selected").text();
        let type = $("input[name='type']:checked").val();
        let typeName = $('input[name="type"]:checked').parent().text();
        
        let startDate = $("#orderStartDate").val();
        let startTime = $("#orderStartTime").val();
        let durationInMinutes = $("#orderDurationInMinutes").children("option:selected").val();

        let firstName = $("#orderFirstName").val();
        let lastName = $("#orderLastName").val();
        let organizationName = $("#orderOrganizationName").val();
        let organizationBusinessId = $("#orderOrganizationBusinessId").val();
        let phoneNumber = $("#orderPhoneNumber").val();
        let email = $("#orderEmail").val();
        let customerNotes = $("#orderNotes").val();
        let location = $("#orderLocations").children("option:selected").val();
        let locationOther = $("#orderLocationOther").val();
        let onSiteAddress = $("#orderOnSiteAddress").val();
        let onSiteBillingAddress = $("#orderOnSiteBillingAddress").val();
        let onSiteCity = $("#orderOnSiteCity").val();
        let onSiteLocationInfo = $("#orderOnSiteLocationInfo").val();
        let paymentType = $("#orderPaymentType").children("option:selected").val();
        let billingAddress = $("#orderBillingAddress").val();
        let drivingSchoolName = $("#orderDrivingSchoolName").val();
        let securityCleared = $("input[name='securityCleared']:checked").val();

        if(fromLanguage != undefined) order.fromLanguage = fromLanguage;
        if(fromLanguageName != undefined && fromLanguageName !== '') order.fromLanguageName = fromLanguageName;
        if(toLanguage != undefined) order.toLanguage = toLanguage;
        if(toLanguageName != undefined && toLanguageName !== '') order.toLanguageName = toLanguageName;
        if(type != undefined) order.type = type;
        if(typeName != undefined  && typeName !== '') order.typeName = typeName;
        
        if(startDate != undefined) order.startDate = startDate;
        if(startTime != undefined) order.startTime = startTime;
        if(durationInMinutes != undefined) order.durationInMinutes = durationInMinutes;

        if(firstName != undefined) order.firstName = firstName;
        if(lastName != undefined) order.lastName = lastName;
        if(organizationName != undefined) order.organizationName = organizationName;
        if(organizationBusinessId != undefined) order.organizationBusinessId = organizationBusinessId;
        if(phoneNumber != undefined) order.phoneNumber = phoneNumber;
        if(email != undefined) order.email = email;
        if(customerNotes != undefined) order.customerNotes = customerNotes;

        if (location != undefined) order.location = location;
        if (locationOther != undefined) order.locationOther = locationOther;
        if (onSiteAddress != undefined) order.onSiteAddress = onSiteAddress;
        if (onSiteBillingAddress != undefined) order.onSiteBillingAddress = onSiteBillingAddress;
        if (onSiteCity != undefined) order.onSiteCity = onSiteCity;
        if (onSiteLocationInfo != undefined) order.onSiteLocationInfo = onSiteLocationInfo;
        if (paymentType != undefined) order.paymentType = paymentType;
        if (billingAddress != undefined) order.billingAddress = billingAddress;
        if (drivingSchoolName != undefined) order.drivingSchoolName = drivingSchoolName;
        if (securityCleared != undefined) order.securityCleared = securityCleared;

        sessionStorage.order = JSON.stringify(order);

        if(order.location === "other") {
            $("#orderLocationOther").prop("hidden",false);
            $("#orderLocationOther").prop("required",true);
            $("#orderLocationOtherLabel").prop("hidden",false);
        }else {
            $("#orderLocationOther").prop("hidden",true);
            $("#orderLocationOther").prop("required",false);
            $("#orderLocationOtherLabel").prop("hidden",true);
        }
        //console.log(sessionStorage.order);
    }

    function setSendBtnDisabled(){
        $("#orderSendBtn").prop("disabled",true);
        $("#orderSendBtn").html(
         '<span class="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>' + common[language].loading
       );
    }

    function setSendBtnActive(){
        $("#orderSendBtn").prop("disabled",false);
        $("#orderSendBtn").html(common[language].send);
    }

    function showAlert(){
        let number = $("#phoneSales").val();
        let numberCaption = $("#phoneSalesCaption").val();
        $("#alert-space").html(
          '<div class="alert alert-warning alert-dismissible fade show" role="alert">' + common[language].alertSubmitFailed + '<a href="tel:'+number+'">'+numberCaption+'</a>.<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>'  
        );
    }

  });

